import { useParams } from "react-router-dom";
import { getCDNUrl } from "../Cloudinary";

const projects = {
    "cover-spring26": {
        title: "Sparks Magazine Issue No. 30 | University of Florida",
        media: [
            {   
                type: "image",
                src: getCDNUrl("Sp2026_Cover_c9tioo", "f_auto,q_auto:best"),
            },
            {
                type: "image",
                src: getCDNUrl("Sp2026_Cover2_upjwd0", "f_auto,q_auto:best"),
            },
            
        ],
        description: <div>
            <p>Cover for <a href="https://issuu.com/sparksmagazine/docs/sparks_magazine_issue_no._30_university_of_flori" target="_blank" rel="noopener noreferrer">Issue 30</a> </p> 
            <a href="https://issuu.com/sparksmagazine/docs/sparks_magazine_issue_no._30_university_of_flori" target="_blank" rel="noopener noreferrer"> </a>

        </div>,
        software: "InDesign, Photoshop"
    },
    
    "ink-mag": {
        title: "Sparks Magazine Issue No. 28 | University of Florida",
        media: [
            {   
                type: "image",
                src: getCDNUrl("Ink_magazine_pg1_g6thfp", "f_auto,q_auto:best"),
            },
            {
                type: "image",
                src: getCDNUrl("ink_magazine_pg2_sagnho", "f_auto,q_auto:best"),
            },
            
        ],
        description: <p>Spread design for <em>Stories Before the Spark: Ink Magazine</em> from <a href="https://issuu.com/sparksmagazine/docs/sparks_magazine_issue_no._27_univer_90c2de8ad68a76" target="_blank" rel="noopener noreferrer">Issue 28</a></p>,
        software: "InDesign, Procreate"
    },

    "matcha": {
        title: "Sparks Magazine Issue No. 29 | University of Florida",
        media: [
            {
                type: "image",
                src: getCDNUrl("rise_and_reinvention_of_matcha_pg1_wn7oqu", "f_auto,q_auto:best"),

            },
            {
                type: "image",
                src: getCDNUrl("rise_and_reinvention_of_matcha_pg2_pss0zv", "f_auto,q_auto:best")
            },
        ],
        description: <p>Spread design for <em>The Rise and Reinvention of Matcha</em> from <a href="https://issuu.com/sparksmagazine/docs/issue_28_university_of_florida" target="_blank" rel="noopener noreferrer">Issue 29</a></p>,
        software: "InDesign, Photoshop, Procreate"
    },

    "candle-forest": {
        title: <div><em>Forest of Candles</em> Animation</div>,
        media: [
            {
                type: "video",
                src: "https://res.cloudinary.com/dmr4kfndo/video/upload/v1766963723/CHUI_DPS1_FINAL_ptstrl.mp4",
            },
        ],
        description: <p>Animation of a whimsical forest made of candles</p>,
        software: "After Effects, Photoshop, Procreate"
    },

    "circus-text": {
        title: "Circus Theme Text Motion Design",
        media: [
            {
                type: "video",
                src: "https://res.cloudinary.com/dmr4kfndo/video/upload/v1766963665/CHUI_DPS1_05_pcoiif.mp4",
            },
        ],
        description: <div>
                <p>Animated text inspired by ornate font</p> 
                <a href="https://www.behance.net/gallery/235978309/Assignment-5-Text-Masking-Design" target="_blank" rel="noopener noreferrer"> Learn more about process</a>
            </div>,
        software: "After Effects"
    },

    "coffee-ad": {
        title: "Coffee Ad",
        media: [
            {
                type: "video",
                src: "https://res.cloudinary.com/dmr4kfndo/video/upload/v1766963666/CHUI_DPS1_07_wzohcw.mp4",
            },
        ],
        description: <div>
                <p>Advertisement for a fictional coffee brand</p> 
                <a href="https://www.behance.net/gallery/236835705/Assignment-7-Social-Media-Ad" target="_blank" rel="noopener noreferrer"> Learn more about process</a>
            </div>,
        software: "After Effects"
    },

    "sparks-web-design": {
        title: "UF Sparks Magazine Web Design",
        media: [
            {
                type: "image",
                src: getCDNUrl("rise_and_reinvention_of_matcha_pg1_wn7oqu", "f_auto,q_auto:best"),
            },
        ],
        description: ""
    },

    "no-laughing-matter": {
        title: <div><em>No Laughing Matter</em> Board Game</div>,
        media: [
            {
                type: "image",
                src: getCDNUrl("no-laughing-matter-pg1_rjdroe", "f_auto,q_auto:best"),

            },
            {
                type: "image",
                src: getCDNUrl("no-laughing-matter-pg2_xxoy3g", "f_auto,q_auto:best"),
            },
        ],
        description: <p>Board and card designs for a fictional horror circus themed board game</p>,
        software: "Procreate"
    },

    "clockwork-repair": {
        title: <div><em>Clockwork Repair</em> 2D Platform Game</div>,
        media: [
            {
                type: "image",
                src: getCDNUrl("clockwork-repair-asset_dihgut", "f_auto,q_auto:best"),

            },
            {
                type: "image",
                src: getCDNUrl("clockwork-repair-asset2_dveiny", "f_auto,q_auto:best"),
            },
            {
                type: "image",
                src: getCDNUrl("clockwork-repair-asset3_ivjpg0", "f_auto,q_auto:best"),
            },
            {
                type: "image",
                src: getCDNUrl("clockwork-repair-ingame_oi9alt", "f_auto,q_auto:best"),
            },
        ],
        description: <div><p>Pixel art assets for a steampunk 2D platform game</p>
        <div className="description-button">
            <a href="https://celineh.itch.io/clockwork-repair" className="coding-proj-button" target="_blank" rel="noopener noreferrer">Play Game</a>
        </div>
        </div>,
        software: "PixilArt, Photoshop, Unity"
    },

    "lunar-new-year": {
        title: "Lunar New Year Poster Design",
        media: [
            {
                type: "image",
                src: getCDNUrl("new-year-ad-1200_kcm8am", "f_auto,q_auto:best"),

            },
        ],
        description: "",
        software: "Procreate"
    },

    "sleep-habits": {
        title: "UF Student Sleeping Habits Poster Design",
        media: [
            {
                type: "image",
                src: getCDNUrl("sleep-info-1200_im4sv7", "f_auto,q_auto:best"),
            },
        ],
        description: "",
        software: "Illustrator, Procreate"
    },
}

export default function ProjectPage() {
    const {page} = useParams();
    const project = projects[page];

    return (
        <div>
            <h2>{project.title}</h2>

            <div className={`project-page-media 
                ${project.media.length === 1 ? "singleImg" : ""}
                ${project.media.length === 4 ? "fourImgs" : ""}
                `}
            >
                {project.media.map((item, i) => {
                    if(item.type === "image") {
                        return(
                            <img
                                alt=""
                                key={i}
                                src={item.src}
                                loading="lazy"
                            />
                        );
                    }

                    if(item.type === "video") {
                        return(
                            <video
                                key={i}
                                src={item.src}
                                preload="metadata"
                                playsInline
                                controls
                            />
                        );
                    }

                    return null;
            })}
            </div>
            <div className="project-page-text">
                {project.description}
                <p className="software-text">Software Used: {project.software}</p>
            </div>
        </div>
    );
}